<template>
  <div>
    <main-scn
      :title="$t('generalPolitic.mainTitle')"
      :highlighted-word-index="1"
      image-url-path="footer-links/fundo-politica-geral.jpg"
    />
    <scn>
      <section-header
        :title="$t('generalPolitic.introduction.title')"
        :subtitle="$t('generalPolitic.introduction.subtitle')"
      />
      <div class="scn__content container">
        <p v-for="(paragraph, index) in $t('generalPolitic.introduction.paragraphs')" class="mb-3">
          {{ paragraph }}
          <img v-if="index === 0" :src="$getImage('footer-links/honestidade.svg')" :alt="`${$t('alt.logo')} Onesti`" class="honesty-image">
        </p>
        <section-subtitle :title="$t('generalPolitic.environment.title')" :highlighted-word-index="1" />

        <div class="two-col-content two-col-content--sm-l sm-l:items-center md:items-center md:mb-3">
          <div class="two-col-content__col md:mr-4 sm-l: mb-3">
            <p v-for="paragraph in $t('generalPolitic.environment.paragraphs')">
              {{ paragraph }}
            </p>
          </div>
          <div class="two-col-content__col mt-4 mb-3 sm-l:mt-0 sm-l:ml-3 md:mt-0 md:mb-0 md:px-6">
            <img :src="$getImage('footer-links/reduza-reuse-recicle-respeite.svg')" :alt="`${$t('alt.logo')} Onesti`">
          </div>
        </div>

        <section-subtitle :title="$t('generalPolitic.slaveLabor.title')" :highlighted-word-index="1" />
        <p v-for="paragraph in $t('generalPolitic.slaveLabor.paragraphs')" class="mb-3">
          {{ paragraph }}
        </p>

        <section-subtitle :title="$t('generalPolitic.inclusion.title')" :highlighted-word-index="2" />

        <div class="two-col-content two-col-content--sm-l sm-l:items-center md:items-center">
          <div class="two-col-content__col md:mr-4">
            <p v-for="paragraph in $t('generalPolitic.inclusion.paragraphs')" class="mb-3">
              {{ paragraph }}
            </p>
          </div>
          <div class="two-col-content__col mt-4 sm-l:mt-0 sm-l:ml-3 md:mt-0 md:px-5">
            <img :src="$getImage('footer-links/juntos-somos-mais-fortes.svg')" :alt="`${$t('alt.logo')} Onesti`">
          </div>
        </div>

        <section-subtitle :title="$t('generalPolitic.harassment.title')" />
        <p v-for="paragraph in $t('generalPolitic.harassment.paragraphs')" class="mb-3">
          {{ paragraph }}
        </p>

        <section-subtitle :title="$t('generalPolitic.antiCorruption.title')" />
        <p v-for="paragraph in $t('generalPolitic.antiCorruption.paragraphs')" class="mb-3">
          {{ paragraph }}
        </p>

        <section-subtitle :title="$t('generalPolitic.data.title')" :highlighted-word-index="2" />
        <p v-for="paragraph in $t('generalPolitic.data.paragraphs')" class="mb-3">
          {{ paragraph }}
        </p>

        <section-subtitle :title="$t('generalPolitic.confidentiality.title')" />
        <div class="two-col-content two-col-content--sm-l sm-l:items-center md:items-center md:mb-3">
          <div class="two-col-content__col md:mr-4">
            <p v-for="paragraph in $t('generalPolitic.confidentiality.paragraphs')">
              {{ paragraph }}
            </p>
          </div>
          <div class="two-col-content__col text-center mt-4 sm-l:mt-0 sm-l:ml-3 md:mt-0">
            <img :src="$getImage('footer-links/mulher-sinal-silencio.jpg')" :alt="`${$t('alt.logo')} Onesti`">
          </div>
        </div>

        <section-subtitle :title="$t('generalPolitic.antiCompetitive.title')" :highlighted-word-index="1" />
        <div class="two-col-content two-col-content--sm-l sm-l:items-center md:items-center md:mb-3">
          <div class="two-col-content__col md:pr-6">
            <img :src="$getImage(`onesti-logo/onesti-logo-${currentLocale}.svg`)" :alt="`${$t('alt.logo')} Onesti`">
          </div>
          <div class="two-col-content__col mt-4 sm-l:mt-0 sm-l:ml-3 md:mt-0">
            <p v-for="paragraph in $t('generalPolitic.antiCompetitive.paragraphs')">
              {{ paragraph }}
            </p>
          </div>
        </div>

        <section-subtitle :title="$t('generalPolitic.proBono.title')" />
        <p v-for="paragraph in $t('generalPolitic.proBono.paragraphs')" class="mb-3">
          {{ paragraph }}
        </p>

        <section-subtitle :title="$t('generalPolitic.management.title')" :highlighted-word-index="2" />
        <p v-for="paragraph in $t('generalPolitic.management.paragraphs')" class="mb-3">
          {{ paragraph }}
        </p>
        <download-button pdf-file-name="politica-geral.pdf" />
      </div>
    </scn>
  </div>
</template>

<script>
import MainScn from '@/components/main-scn'
import SectionSubtitle from '@/components/section-subtitle'
import DownloadButton from '@/components/download-button'
export default {
  name: 'GeneralPolitic',
  components: { DownloadButton, SectionSubtitle, MainScn },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  }
}
</script>

<style scoped lang="sass">
@tailwind utilities

.honesty-image
  @apply hidden
  @screen md
    @apply inline float-right w-16 ml-3 mb-3
</style>
